import { z } from 'zod';
import { AttributeKeySchema, type AttributeKey } from '@/IsekaiRPG/modules/character/characterAttributeTypes';

export const FlatEffectMagnitudeSchema = z.object({
  mode: z.literal('flat'),
  value: z.number().min(0),
});
export type FlatEffectMagnitude = z.infer<typeof FlatEffectMagnitudeSchema>;

export const SourceAttributeEffectMagnitudeSchema = z.object({
  mode: z.literal('source_attribute'),
  attribute: AttributeKeySchema,
  coefficient: z.number().min(0),
  minimumAttribute: z.number().min(0).default(0),
  levelCoefficient: z.number().min(0).default(0),
});
export type SourceAttributeEffectMagnitude = z.infer<typeof SourceAttributeEffectMagnitudeSchema>;

export const TargetMaxHpRatioEffectMagnitudeSchema = z.object({
  mode: z.literal('target_max_hp_ratio'),
  ratio: z.number().min(0),
});
export type TargetMaxHpRatioEffectMagnitude = z.infer<typeof TargetMaxHpRatioEffectMagnitudeSchema>;

export const EffectMagnitudeSchema = z.discriminatedUnion('mode', [
  FlatEffectMagnitudeSchema,
  SourceAttributeEffectMagnitudeSchema,
  TargetMaxHpRatioEffectMagnitudeSchema,
]);
export type EffectMagnitude = z.infer<typeof EffectMagnitudeSchema>;

export const HealGameplayEffectSchema = z.object({
  type: z.literal('heal'),
  magnitude: EffectMagnitudeSchema,
});
export type HealGameplayEffect = z.infer<typeof HealGameplayEffectSchema>;

/**
 * 通用效果 Schema。后续新增伤害或状态效果时在此扩展联合类型。
 */
export const GameplayEffectSchema = HealGameplayEffectSchema;
export type GameplayEffect = z.infer<typeof GameplayEffectSchema>;

export interface EffectTargetSnapshot {
  hp: number;
  maxHp: number;
}

export interface EffectSourceSnapshot {
  level: number;
  attributes: Partial<Record<AttributeKey, number>>;
}

export interface EffectResolutionContext {
  source?: EffectSourceSnapshot;
  target: EffectTargetSnapshot;
}

export interface HealEffectResolution {
  type: 'heal';
  requestedValue: number;
  appliedValue: number;
  nextHp: number;
  success: boolean;
  reason?: 'target_at_full_health' | 'zero_magnitude';
}

export type GameplayEffectResolution = HealEffectResolution;
